module.exports = __webpack_public_path__ + "img/icon_nav6.d13c1773.10471f8b.svg";